import map from 'lodash/map'
import { useMemo } from 'react'
import { Highlight, Snippet } from 'react-instantsearch-dom'
import { useSearchHits } from '../SearchHitsContext'

export const useNewsSearchHitsAsArticles = () => {
  const hits = useSearchHits()

  const articles = useMemo(() => {
    return map(hits, (hit) => {
      const matchedTitle = hit._highlightResult.title.matchLevel !== 'none'
      const matchedPreviewText =
        hit._highlightResult.previewText &&
        hit._highlightResult.previewText.matchLevel !== 'none'
      const matchedFullText = hit._snippetResult.fullText.matchLevel !== 'none'
      const showFullTextSnippet =
        !matchedTitle && !matchedPreviewText && matchedFullText

      // return <SimpleJson value={props} />
      const previewTextHighlight = (
        <Highlight hit={hit} attribute="previewText" tagName="mark" />
      )
      const titleHighlight = (
        <Highlight hit={hit} attribute="title" tagName="mark" />
      )
      const fullTextSnippet = (
        <>
          ...{' '}
          <Snippet
            hit={hit}
            attribute="fullText"
            highlightProperty="_snippetResult"
            tagName="mark"
          />
          ...{' '}
        </>
      )
      const image = hit.imageUrl ? { url: hit.imageUrl } : undefined
      const previewText = showFullTextSnippet
        ? fullTextSnippet
        : previewTextHighlight
      return { ...hit, image, previewText, title: titleHighlight }
    })
  }, [hits])

  return articles
}
